import { render, staticRenderFns } from "./Parallax.vue?vue&type=template&id=76aef0af"
import script from "./Parallax.vue?vue&type=script&lang=js"
export * from "./Parallax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports